import {
	Button,
	Flex,
	SlidedownPortal,
	StandardModal,
	TextButton,
} from '@bamboohr/fabric';
import {
	getPasskeyUserFlag,
	hasAcknowledgedPasskeys,
	hasSeenRecommendPasskeysModal,
	setPasskeyUserFlag,
	isKnownPasskeyUser,
	isPasskeySupported,
	registerPasskey,
	setAcknowledgedPasskeys,
	setRecommendPasskeysShown,
	clearAcknowledgedPasskeys,
	clearRecommendPasskeysShown,
} from '@bamboohr/utils/lib/authentication';
import { getSessionCompany } from '@utils/global-data-service';
import { render } from 'base/wrapped-render-v2';
import { useState } from 'react';
import { PasskeyFacts } from '../login/login/components/passkey-facts';

export async function showRecommendPasskeysModal() {
	// If the user has already seen the modal in the current session, don't show it again.
	if (hasSeenRecommendPasskeysModal()) {
		return;
	}
	const { sessionCompany } = await getSessionCompany();
	const { passkeyReminderFlag } = await getPasskeyUserFlag();

	if (passkeyReminderFlag === 'passkeys_acknowledged') {
		setAcknowledgedPasskeys();
		setRecommendPasskeysShown();
	} else if (passkeyReminderFlag === 'remind_me_later') {
		clearAcknowledgedPasskeys();
	} else {
		clearAcknowledgedPasskeys();
		clearRecommendPasskeysShown();
	}

	if (
		isPasskeySupported() &&
		sessionCompany?.passkeysEnabled &&
		!window.SESSION_USER.hasPasskey &&
		!isKnownPasskeyUser() &&
		!hasAcknowledgedPasskeys()
	) {
		render({
			children: <RecommendPasskeysModal />,
			attachedElement: document.createElement('div'),
		});
		setRecommendPasskeysShown();
	}
}

function RecommendPasskeysModal() {
	const recommendPasskeysModalBiId = 'recommend-passkeys-modal';
	const [isModalOpen, setIsModalOpen] = useState(true);
	const [isSuccessSlidedownOpen, setIsSuccessSlidedownOpen] = useState(false);

	const handleRemindMeLater = () => {
		setIsModalOpen(false);
		setPasskeyUserFlag(false);
	};

	const handleNoThanks = () => {
		setIsModalOpen(false);
		setPasskeyUserFlag(true);
	};

	const handleAddPasskey = async () => {
		await registerPasskey();
		setIsSuccessSlidedownOpen(true);
		setIsModalOpen(false);
		// exceptions handled in registerPasskey
	};

	return (
		<>
			<SlidedownPortal
				description={`${$.__(
					'Next time you log in you can use passkeys.',
				)} ${$.__('Manage passkeys from your user account settings.')}`}
				message={$.__('Success! Passkey created.')}
				onDismiss={() => setIsSuccessSlidedownOpen(false)}
				show={isSuccessSlidedownOpen}
				type="success"
			/>
			<StandardModal isOpen={isModalOpen} onRequestClose={handleRemindMeLater}>
				<StandardModal.Body
					renderFooter={
						<StandardModal.Footer
							actions={[
								<TextButton
									data-bi-id={`${recommendPasskeysModalBiId}-no-thanks`}
									key="noThanks"
									onClick={handleNoThanks}
								>
									{$.__('No Thanks')}
								</TextButton>,
								<Button
									data-bi-id={`${recommendPasskeysModalBiId}-remind-me-later`}
									key="remindMeLater"
									onClick={handleRemindMeLater}
									variant="outlined"
								>
									{$.__('Remind Me Later')}
								</Button>,
								<Button
									data-bi-id={`${recommendPasskeysModalBiId}-add-passkey`}
									key="addPasskey"
									onClick={handleAddPasskey}
								>
									{$.__('Add a Passkey')}
								</Button>,
							]}
						/>
					}
					renderHeader={
						<StandardModal.Header
							biId={recommendPasskeysModalBiId}
							title={$.__('Goodbye passwords. Hello passkeys! ')}
						/>
					}
					size="medium"
				>
					<StandardModal.Constraint>
						<Flex gap={4}>
							<PasskeyFacts
								bodyToBulletGap={3}
								bulletPointGap={1.5}
								showLearnMore={true}
							/>
							<img
								alt="key with lock"
								height="162"
								src="https://staticfe.bamboohr.com/assets/images/user-key.svg"
								width="165"
							/>
						</Flex>
					</StandardModal.Constraint>
				</StandardModal.Body>
			</StandardModal>
		</>
	);
}
